/* unplugin-vue-components disabled */import script from "./CartItems.vue?vue&type=script&setup=true&lang=js"
export * from "./CartItems.vue?vue&type=script&setup=true&lang=js"

import "./CartItems.vue?vue&type=style&index=0&id=741b3690&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-741b3690"]])

export default __exports__